import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import {
  TaxStrategyDetailsContainer,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsContainer';


const ScenarioSelectionRedefinedTaxStrategyStepLayout = ({
  resource,
}) => {
  return resource.withRelationship(
    fr.relationships.proposalScenarioTaxStrategyDetails.name,
    (rel) => (
      <TaxStrategyDetailsContainer relationship={rel} />
    ),
    () => null,
  );
};

ScenarioSelectionRedefinedTaxStrategyStepLayout.defaultProps = {
};

ScenarioSelectionRedefinedTaxStrategyStepLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedTaxStrategyStepLayout;
